import React from 'react';
import { useLocation } from 'react-router-dom';
import { useSiteGate } from '@/context/SiteGateContext';
import SiteGate from '@/pages/SiteGate';

const SiteGateGuard = ({ children }) => {
  const { enabled, authenticated, loading } = useSiteGate();
  const location = useLocation();
  const isAdminRoute = location.pathname.startsWith('/admin');

  if (isAdminRoute) {
    return children;
  }

  if (loading) {
    return (
      <div className="min-h-screen bg-byron-bg flex items-center justify-center">
        <div className="text-center">
          <img src="/byron-logo-transparent-26.svg" alt="Byrōn Properties" className="h-8 mx-auto mb-4 opacity-60" />
          <p className="text-sm uppercase tracking-[0.2em] text-[#6B6B6B]">Loading...</p>
        </div>
      </div>
    );
  }

  if (enabled && !authenticated) {
    return <SiteGate />;
  }

  return children;
};

export default SiteGateGuard;
